// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604231519/js/" + chunkId + "." + {"44":"c1c83a34","225":"cb3caa22","481":"2eaf8196","486":"7be5f878","770":"55098b7c"}[chunkId] + ".0.2504649817178046.chunk.js";
};